import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import { smsNotificationText } from '../models/smsNotificationText';
import { CucurachaAdminService } from '../service/cucuracha.service';
@Component({
  selector: 'app-smsnotificationtextmanagement',
  templateUrl: './smsnotificationtextmanagement.component.html',
  styleUrls: ['./smsnotificationtextmanagement.component.css']
})
export class SmsnotificationtextmanagementComponent implements OnInit {
  @ViewChild(MatSort,{static:true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("smsNotificationText") form: any;
  @ViewChild("smsNotificationTextUpdate", {static: true}) formUpdate: any;

  smsNotificationTextAddObj:smsNotificationText
  dataSource:any;
  displayedColumns = [ 'notificationType', 'notificationTitle','notificationTextDescription' ,'status','Action']
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any
  show:boolean=false

  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager) { 
    this.smsNotificationTextAddObj= new smsNotificationText()
  }
  addAppNotificationText(){
    if(this.show==false){
      this.show=true
      this.form.reset();
      this.formUpdate.reset()

    }
    else{
      this.show=false
      this.form.reset()
      this.formUpdate.reset()

    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  saveSmsNotificationTexts(){
    this.cs.saveSmsNotificationTexts(this.smsNotificationTextAddObj).subscribe((data) => {
      if(data.result ){
        this.getAllSmsNotificationTexts();
        this.toastr.successToastr(data.message);
        this.form.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
        });
   
  }
  getAllSmsNotificationTexts(){
    this.cs.getAllSmsNotificationTexts().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  getBySmsTextNotificationId(id:any){
    this.cs.getBySmsNotificationTextId(id).subscribe((data) => {
      console.log(data)
      this.smsNotificationTextAddObj._id=data[0]._id;
  
      this.smsNotificationTextAddObj.notificationType=data[0].notificationType
      this.smsNotificationTextAddObj.notificationTitle=data[0].notificationTitle
      this.smsNotificationTextAddObj.notificationTextDescription=data[0].notificationTextDescription
      
    })
  }
  updateSmsNotificationText(){
    this.cs.updateSmsNotificationText(this.smsNotificationTextAddObj).subscribe((data) => {
      if(data.result ){
        this.getAllSmsNotificationTexts();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  deleteSmsNotificationText(id:any){
    this.cs.deleteSmsNotificationText(id).subscribe((data) => {
      this.getAllSmsNotificationTexts()
      this.toastr.warningToastr("Data  Deleted");
    })

  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getBySmsNotificationTextId(id).subscribe((data) => {
      console.log(data)
      this.smsNotificationTextAddObj._id=data[0]._id;
  
      this.smsNotificationTextAddObj.notificationType=data[0].notificationType
      this.smsNotificationTextAddObj.notificationTitle=data[0].notificationTitle
      this.smsNotificationTextAddObj.notificationTextDescription=data[0].notificationTextDescription


      this.smsNotificationTextAddObj.status = status.checked;

      this.cs.updateSmsNotificationTextstatus(this.smsNotificationTextAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit();
          this.toastr.successToastr(data.message);
          this.form.reset();
          this.formUpdate.reset();

          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.ngOnInit();

         }
          else{
            this.toastr.errorToastr(data.message);
            this.ngOnInit();

          }
      })
    })
  }
  ngOnInit(): void {
    this.getAllSmsNotificationTexts();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].delete)
    })

  }

}
